import { colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';

interface IContentProps {
  expanded?: boolean;
}

export const ToggleWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-left: auto;
  cursor: pointer;
`;

export const Label = styled.div`
  margin-left: 4px;
  color: ${colors.grey5};
  min-width: 100px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.3px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${colors.grey3};
  height: 48px;
  box-sizing: border-box;
`;

export const ContentRow = styled.div<IContentProps>`
  display: flex;
  transition: height 0.2s ease-out;
  height: 0;
  overflow: hidden;
  box-sizing: border-box;

  ${({ expanded }) =>
    expanded &&
    css`
      height: 48px;
      overflow: hidden;
      border-bottom: 1px dashed ${colors.grey3};
    `};
`;

export const Wrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
`;
